module.exports = __webpack_public_path__ + "images/emoji/wolf.17e3c4ac08bafc511e0a.png";